import PropTypes from "prop-types";
import React, { useState } from "react";
import { IconInterfacesUser } from "../IconInterfacesUser";
import userIcon from "../../img/static/user-icon.svg";
import eyeIcon from "../../img/static/eye-icon.svg";
import hiddenEyeIcon from "../../img/static/hidden-eye-icon.svg";
import "./style.css";

export const TypeForm = ({
  label,
  isPassword = false,
  showIcon = true,
  type = "text",
  className,
  maxLength = 0,
  icon = undefined,
  override = (
    <IconInterfacesUser
      className="icon-interfaces-user-instance"
      combinedShape={icon ?? userIcon}
    />
  ),
  value = "",
  onChange,
  prefix = undefined,
  placeholder = "",
  ...props
}) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const handleInputChange = (e) => {
    onChange?.(e.currentTarget.value);
  };

  const handleIconClick = () => {
    setIsPasswordVisible((prevState) => !prevState);
  };

  return (
    <div className={`type-form ${className}`}>
      {showIcon && (
        <div className="icon">
          {override}
          <div className="divider" />
        </div>
      )}
      {prefix && prefix}
      <input
        {...props}
        maxLength={maxLength === 0 ? 1000000 : maxLength}
        type={isPassword && !isPasswordVisible ? "password" : type}
        className="campo-input"
        placeholder={placeholder || label || ""}
        value={value ?? ""}
        onChange={handleInputChange}
      />
      {maxLength !== 0 ? (
        <div className="text-limit-wrapper">
          <p>
            {value.length}/{maxLength}
          </p>
        </div>
      ) : null}
      {isPassword && (
        <div className="icon" onClick={handleIconClick}>
          <div className="divider" />
          {isPasswordVisible ? (
            <img
              src={eyeIcon}
              alt=""
              className="icon-interfaces-show-password"
            />
          ) : (
            <img
              src={hiddenEyeIcon}
              alt=""
              className="icon-interfaces-show-password"
            />
          )}
        </div>
      )}
    </div>
  );
};

TypeForm.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  showIcon: PropTypes.bool,
  className: PropTypes.string,
  override: PropTypes.node,
  onChange: PropTypes.func,
};

export default TypeForm;
